var _excluded = ["query"],
  _excluded2 = ["query"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { useTheme } from '../../system';
import React from 'react';
import createMediaQueries from './create-media-query';
/**
 * React hook used to get the current responsive media breakpoint.
 *
 * @param defaultBreakpoint default breakpoint name
 * (in non-window environments like SSR)
 *
 * For SSR, you can use a package like [is-mobile](https://github.com/kaimallea/isMobile)
 * to get the default breakpoint value from the user-agent
 */
export function useBreakpoint(defaultBreakpoint) {
  var {
    breakpoints
  } = useTheme();
  var mediaQueries = React.useMemo(() => createMediaQueries(_objectSpread({
    base: '0px'
  }, breakpoints)), [breakpoints]);
  var [currentBreakpoint, setCurrentBreakpoint] = React.useState(() => {
    if (!defaultBreakpoint) {
      return undefined;
    }
    var mediaQuery = mediaQueries.find(_ref => {
      var {
        breakpoint
      } = _ref;
      return breakpoint === defaultBreakpoint;
    });
    if (mediaQuery) {
      var {
          query
        } = mediaQuery,
        breakpoint = _objectWithoutProperties(mediaQuery, _excluded);
      return breakpoint;
    }
    return undefined;
  });
  var current = currentBreakpoint === null || currentBreakpoint === void 0 ? void 0 : currentBreakpoint.breakpoint;
  var update = React.useCallback((query, breakpoint) => {
    if (query.matches && current !== breakpoint.breakpoint) {
      setCurrentBreakpoint(breakpoint);
    }
  }, [current]);
  React.useEffect(() => {
    var listeners = new Set();
    mediaQueries.forEach(_ref2 => {
      var {
          query
        } = _ref2,
        breakpoint = _objectWithoutProperties(_ref2, _excluded2);
      var mediaQuery = window.matchMedia(query);

      // trigger an initial update to determine media query
      update(mediaQuery, breakpoint);
      var handleChange = () => {
        update(mediaQuery, breakpoint);
      };

      // add media query-listener
      mediaQuery.addListener(handleChange);

      // push the media query list handleChange
      // so we can use it to remove Listener
      listeners.add({
        mediaQuery,
        handleChange
      });
      return () => {
        // clean up 1
        mediaQuery.removeListener(handleChange);
      };
    });
    return () => {
      // clean up 2: for safety
      listeners.forEach(_ref3 => {
        var {
          mediaQuery,
          handleChange
        } = _ref3;
        mediaQuery.removeListener(handleChange);
      });
      listeners.clear();
    };
  }, [mediaQueries, breakpoints, update]);
  return current;
}